import { z } from 'zod';

export const baseMessageSchema = z.object({
  timestamp: z.number(),
  id: z.string().uuid(),
});

export type BaseMessage = z.infer<typeof baseMessageSchema>;
